import Vue from 'vue'
import App from './App.vue'
import Notifications from 'vue-notification'
import { VLazyImagePlugin } from "v-lazy-image";

import 'animate.css/animate.min.css';

Vue.use(Notifications)
Vue.use(VLazyImagePlugin)


Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
